import { LocalStorageKeys } from '@constants/enums';
import { selectProfileData } from '@pages/profile/store/selectors';
import { aesDecryptCBC } from '@utils/crypt';
import React from 'react';
import { useSelector } from 'react-redux';

interface IProtected {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<IProtected> = ({ children }) => {
  const userProfile = useSelector(selectProfileData);

  const userEmail = aesDecryptCBC(userProfile?.naturalPerson?.email || '');
  localStorage.setItem(LocalStorageKeys.USER_EMAIL, userEmail);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default ProtectedRoute;
